import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import { Flex } from '@elparking/components'
import TabsList from '../components/TabsList'
import throttle from 'lodash.throttle'

function StickyTabsContainer ({ tabs, defaultTabName, elements }) {
    const [tabNameSelected, setTabSelected] = useState(defaultTabName)
    const memoizeHandleSroll = useCallback(throttle(() => {
        let fromTop = window.scrollY
        elements.forEach((element) => {
            if (
                element.target.offsetTop <= fromTop &&
                element.target.offsetTop + element.target.offsetHeight > fromTop
            ) {
                setTabSelected(element.name)
            }
        })
    }, 100), [elements])

    useEffect(() => {
        window.addEventListener('scroll', memoizeHandleSroll)

        return function cleanup () {
            window.removeEventListener('scroll', memoizeHandleSroll)
        }
    }, [elements, memoizeHandleSroll])

    return (
        <Flex justifyContent={['center', 'start']} h='100%'>
            <TabsList tabs={tabs} tabNameSelected={tabNameSelected} />
        </Flex>
    )
}

StickyTabsContainer.propTypes = {
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            href: PropTypes.string,
        }),
    ),
    defaultTabName: PropTypes.string,
    elements: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            target: PropTypes.object,
        }),
    ),
}

StickyTabsContainer.defaultProps = {
    tabs: [],
}

export default StickyTabsContainer
